module.exports = __webpack_public_path__ + "media/images/banners/subscribe-1165d28e7f08ce1dd30cdc796663fd56.jpg";